<app-page-title ></app-page-title>


<section class="pt-5 pb-5 text-center">
	<img src="assets/images/404.svg" class="mt-5 img-fluid">
	<div class="text-uppercase font-weight-bold">Page not found</div>
</section>
